export const AIRPORT_ID = "airport";
export const AIRPORT_LAT = 36.9043327;
export const AIRPORT_LNG = 30.7993019;

// returns array consisting of
// id (from)
// distance,
// distanceText
// duration,
// durationText
// steps { distance, duration, end_location, html_instructions, polyline, start_location, travel_mode }

export function calculateDistance(points, distances, transferType) {
  let totalDistance = 0;
  for (let i = 0; i < points.length - 1; i++) {
    const currentPoint = points[i];
    const nextPoint = points[i + 1];

    if (transferType.toString() === "100") {
      totalDistance += distances.find((d) => d.to === currentPoint && d.from === nextPoint)?.data?.distance?.value || 0;
    } else {
      totalDistance += distances.find((d) => d.from === currentPoint && d.to === nextPoint)?.data?.distance?.value || 0;
    }
  }
  return totalDistance;
}

function generatePermutations(numbers) {
  if (numbers.length === 1) {
    return [numbers];
  }

  const permutations = [];

  for (let i = 0; i < numbers.length; i++) {
    const currentNumber = numbers[i];
    const remainingNumbers = [...numbers.slice(0, i), ...numbers.slice(i + 1)];
    const subPermutations = generatePermutations(remainingNumbers);

    for (const permutation of subPermutations) {
      permutations.push([currentNumber, ...permutation]);
    }
  }

  return permutations;
}

export function tsp(startingPoint, peopleIds, distances, transferType, destinationId = null) {
  let destinationIdToCheck;
  if (destinationId) {
    destinationIdToCheck = destinationId;
  } else {
    destinationIdToCheck = AIRPORT_ID;
  }

  const allPermutations = generatePermutations([...peopleIds]);
  let shortestDistance = Infinity;
  let shortestRoute;

  for (const permutation of allPermutations) {
    const route = [startingPoint, ...permutation];
    const distance = calculateDistance(route, distances, transferType);

    if (distance < shortestDistance) {
      shortestDistance = distance;
      shortestRoute = route;
    }
  }

  if (transferType.toString() === "100") {
    return {
      distance: shortestDistance,
      route: shortestRoute?.filter((item) => item !== destinationIdToCheck)?.reverse() || [],
    };
  } else {
    return { distance: shortestDistance, route: shortestRoute?.filter((item) => item !== destinationIdToCheck) || [] };
  }
}
